import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import Admin from "./layouts/Admin";
import Auth from "./layouts/Auth";
import Login from "views/auth/Login";
import { Dashboard } from "views/admin/Dashboard";
import Comments from "views/admin/Support/Comments/Comments";
import Crm from "views/admin/Support/Crm/Crm";
import Users from "views/admin/Accounting/Users/Users";
import Directors from "views/admin/Accounting/Directors/Directors";
import Admins from "views/admin/Accounting/Admins/Admins";
import Cafes from "views/admin/Accounting/Cafes/Cafes";
import Resellers from "views/admin/Accounting/Resellers/Resellers";
import Promotions from "views/admin/Accounting/Promotions/Promotions";
import Packages from "views/admin/Seals/Packages/Packages";
import Coupons from "views/admin/Seals/Coupons/Coupons";
import Orders from "views/admin/Seals/Orders/Orders";
import Roles from "views/admin/Accounting/Roles/Roles";
import RoleAdd from "views/admin/Accounting/Roles/Add";
import RoleEdit from "views/admin/Accounting/Roles/Edit";
import ProductCategory from "views/admin/Settings/ProductCategory/ProductCategory";

import PlusProductCategory from "views/admin/Settings/PlusProductCategory/PlusProductCategory";
import ShopProductCategory from "views/admin/Settings/ShopProductCategory/ShopProductCategory";
import BlockedUsers from "views/admin/Accounting/BlockUsers/BlockUsers";
import ResetPassword from "views/auth/ResetPassword";
import { Provider } from "react-redux";
import store from "./store/Store";
import reportWebVitals from "./reportWebVitals";
import ActivityFields from "./views/admin/Settings/ActivityFields/ActivityFields";
import Casts from "./views/admin/Settings/Casts/Casts";
import Genres from "./views/admin/Settings/Genres/Genres";
import DeliveryMethods from "./views/admin/Settings/DeliveryMethods/DeliveryMethods";
import Menus from "./views/admin/Settings/Menus/Menus";
import MenusAdd from "./views/admin/Settings/Menus/Add";
import MenusEdit from "./views/admin/Settings/Menus/Edit";
import Sliders from "./views/admin/Settings/Sliders/Sliders";
import SlidersAdd from "./views/admin/Settings/Sliders/Add";
import SlidersEdit from "./views/admin/Settings/Sliders/Edit";
import Products from "./views/admin/Products/List";
import AddProducts from "./views/admin/Products/Wizard/Wizard";
import Festivals from "views/admin/Products/Festivals/Festivals";
import Lives from "views/admin/Products/Lives/Lives";
import LiveTickets from "views/admin/Products/Lives/Tickets/Tickets";
import FestivalWidgets from "views/admin/Products/Festivals/FestivalWidgets";
import Tickets from "views/admin/Products/Tickets/Tickets";
import CafeTickets from "views/admin/Products/Tickets/CafeTickets";
import Plans from "views/admin/Products/Tickets/Plans";
import Generals from "./views/admin/Settings/Generals/Generals";
import ProductStatusList from "views/admin/ProductStatus/ProductsStatus";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" exact element={<Auth />}>
            <Route path="/auth/login" exact element={<Login />} />
            <Route
              path="/auth/resetpassword"
              exact
              element={<ResetPassword />}
            />
            <Route path="/auth" element={<Navigate to="/auth/login" />} />
          </Route>
          <Route path="/" exact element={<Admin />}>
            <Route path="/dashboard" exact element={<Dashboard />} />
            <Route path="/support/comments" exact element={<Comments />} />
            <Route path="/support/crm" exact element={<Crm />} />
            <Route path="/users/users" exact element={<Users />} />
            <Route path="/users/admins" exact element={<Admins />} />
            <Route path="/users/directors" exact element={<Directors />} />
            <Route path="/users/resellers" exact element={<Resellers />} />
            <Route path="/users/cafes" exact element={<Cafes />} />
            <Route path="/users/roles" exact element={<Roles />} />
            <Route path="/users/promotions" exact element={<Promotions />} />
            <Route path="/users/roles/add" exact element={<RoleAdd />} />
            <Route path="/users/roles/edit/:id" exact element={<RoleEdit />} />
            <Route path="/users/blocked" exact element={<BlockedUsers />} />
            <Route path="/settings/general" exact element={<Generals />} />
            <Route
              path="/settings/product-categories"
              exact
              element={<ProductCategory />}
            />
            <Route
              path="/settings/plus-product-categories"
              exact
              element={<PlusProductCategory />}
            />
            <Route
              path="/settings/shop-product-categories"
              exact
              element={<ShopProductCategory />}
            />
            <Route
              path="/settings/activity-Fields"
              exact
              element={<ActivityFields />}
            />
            <Route path="/settings/casts" exact element={<Casts />} />
            <Route path="/settings/genres" exact element={<Genres />} />
            <Route
              path="/settings/delivery-methods"
              exact
              element={<DeliveryMethods />}
            />
            <Route path="/settings/menus" exact element={<Menus />} />
            <Route path="/settings/menus/add" exact element={<MenusAdd />} />
            <Route
              path="/settings/menus/edit/:id"
              exact
              element={<MenusEdit />}
            />
            <Route path="/settings/Sliders" exact element={<Sliders />} />
            <Route
              path="/settings/Sliders/add"
              exact
              element={<SlidersAdd />}
            />
            <Route
              path="/settings/Sliders/edit/:id"
              exact
              element={<SlidersEdit />}
            />
            <Route
              path="/products/Plus"
              exact
              element={<Products plus={true} />}
            />
            <Route path="/products/lives" exact element={<Lives />} />
            <Route
              path="/products/lives/:live_id/tickets"
              exact
              element={<LiveTickets />}
            />
            <Route path="/products/festivals" exact element={<Festivals />} />
            <Route
              path="/products/festival/:id/widgets"
              exact
              element={<FestivalWidgets />}
            />
            <Route
              path="/products/wizard/:id"
              exact
              element={<AddProducts />}
            />
            <Route
              path="/products/festival/:festival_id/:festival_name"
              exact
              element={<Products />}
            />
            <Route
              path="/products/festival/:festival_id"
              exact
              element={<Products />}
            />

            <Route
              path="/products/festival/:festival_id/wizard"
              exact
              element={<AddProducts festival={true} />}
            />
            <Route
              path="/products/festival/:festival_id/wizard/:id"
              exact
              element={<AddProducts festival={true} />}
            />
            <Route path="/products/wizard" exact element={<AddProducts />} />
            <Route path="/products/:type" exact element={<Products />} />
            <Route path="/products" exact element={<Products />} />

            <Route
              path="/tickets/:product_id/:plan_name/:product_name"
              exact
              element={<Tickets />}
            />
            <Route
              path="/tickets/:product_id/:plan_name"
              exact
              element={<Tickets />}
            />
            <Route
              path="/cafe-tickets/:plan_id"
              exact
              element={<CafeTickets />}
            />

            <Route
              path="/cafe-tickets/:plan_id/:plan_name"
              exact
              element={<CafeTickets />}
            />
            <Route
              path="/plans/:product_id/:product_name"
              exact
              element={<Plans />}
            />
            <Route path="/seals/packages" exact element={<Packages />} />
            <Route path="/seals/coupons" exact element={<Coupons />} />
            <Route path="/seals/orders" exact element={<Orders />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />

            <Route path="/products-status" element={<ProductStatusList />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
